// extracted by mini-css-extract-plugin
module.exports = {"select":"Select_select__JK0vz","select__control":"Select_select__control__2okwx"};